__turbopack_context__.v({
  "image": "image-slide-module__G5I3XG__image",
  "slide": "image-slide-module__G5I3XG__slide",
});
